import React from 'react';
import { Icon } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../DeepAnalysis.less';

type Props = {
    title: string | JSX.Element;
    showRedirectArrow?: boolean;
    fallbackPath?: string;
    leftSideExtra?: string | JSX.Element | JSX.Element[];
    rightSideExtra?: string | JSX.Element | JSX.Element[];
};

export default function Header({ title, showRedirectArrow, fallbackPath, leftSideExtra, rightSideExtra }: Props) {
    const navigate = useNavigate();

    return (
        <div className="deep-analysis-header">
            <div className="main-content">
                {showRedirectArrow && (
                    <Icon
                        style={{ fontSize: '20px', color: '#000' }}
                        onClick={() => window.history.length > 1 ? navigate(-1) : (fallbackPath ? navigate(fallbackPath) : navigate('/deep-analysis'))}
                        type="arrow-left"
                    />
                )}

                <div className="title">{title}</div>
                {typeof leftSideExtra !== 'undefined' && <div className="left-side-content">{leftSideExtra}</div>}
            </div>
            <div className="right-side-content">{rightSideExtra}</div>
        </div>
    );
}
